<template>
  <span class="flag-emoji">{{ flagEmoji }}</span>
</template>
<script>
export default {
  name: 'FlagEmoji',
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  computed: {
    flagEmoji() {
      const codigo = this.code
      const offset = 127397
      let emoji = ''
      for (let i = 0; i < codigo.length; i++) {
        emoji += String.fromCodePoint(codigo.charCodeAt(i) + offset)
      }
      return emoji
    },
  },
}
</script>

<style lang="scss" scoped>
.flag-emoji {
}
</style>
